import updateUser from './updateUser';

const doLogout = ()=>{
    
    updateUser({id:null, agent_id:null, name:null, passport:null, email:null, phone:null, company:null, logo:null})

  }

export default doLogout;